module.exports = __webpack_public_path__ + "img/certificate-1.4ab4dd70.png";